var Header = function () {

	this.init = function () {

		if ($(window).width() > 992) {
			$('.main-menu [data-submenu]').on('click', function(e) {
				e.preventDefault();

				if ($(this).closest('li').hasClass('highlight')) {

					$('.main-menu li').removeClass('highlight');
					$('.submenu').slideUp();
				} 
				else {
					
					$('.main-menu li').removeClass('highlight');
					$(this).closest('li').addClass('highlight');
					$('.submenu').slideUp();
					$('.submenu[data-submenu="'+$(this).data('submenu')+'"]').slideDown();	
				}
			});

			$('html, body').on('click', function(e) {

				if ($(e.target).closest('.main-menu').length < 1 && $(e.target).closest('[data-component="submenu"]').length < 1) {
					$('.main-menu li').removeClass('highlight');
					$('.submenu').slideUp();
				}
			});

		} 
		else {

			$('.main-menu [data-submenu]').on('click', function (e) {
				e.preventDefault();
				var $sub = $(this).data('submenu');
				$('.button-menu').addClass('back-menu');
				$('.submenu').hide();
				$('.submenu[data-submenu="' + $sub + '"]').show();
				$('[data-component="submenu"]').css('left', 0);
				TweenMax.to($('.submenu[data-submenu="' + $sub + '"]'), .7, {
					left: 0,
					ease: Quint.easeOut
				});
			});
		}

		$('.button-menu').on('click', function (e) {

			if ($(this).hasClass('back-menu')) {
				TweenMax.to($('[data-component="submenu"]'), 0, {
					left: '100%',
					ease: Quint.easeOut,
				});

				$(this).removeClass('back-menu');
			} 
			else {

				if ($(this).hasClass('open')) {

					$('body, html').css("overflow", "scroll");
					TweenMax.to($('.main-menu'), .8, { left: '100%', ease: Quint.easeOut });
					$('main, footer').fadeIn(300);
					//TweenMax.to($('main, footer'), .8, { opacity: '1', ease: Sine.easeOut });
					$(this).removeClass('open');
					$('[data-component="header"]').removeClass('open-mobile-menu');
				} 
				else {

					$('body, html').css({"overflow":"hidden","position":"relative"});
					TweenMax.to($('.main-menu'), .8, { left: 0, ease: Quint.easeOut });
					$('main, footer').fadeOut(300);
					//TweenMax.to($('main, footer'), .8, { opacity: '0', ease: Sine.easeOut });
					$(this).addClass('open');
					$('[data-component="header"]').addClass('open-mobile-menu');
				}
			}
		});

		$('.search').on('click', function (e) {
			$('.main-menu li').removeClass('highlight');
			if( $(window).width() > 992 ) {
				$('.submenu').slideUp();
			}
			TweenMax.to($('[data-component="search"]'), .8, { top: 0, ease: Quint.easeOut });
		});

		$('[data-component="search"] .close').on('click', function (e) {
			TweenMax.to($('[data-component="search"]'), .8, { top: '-100%', ease: Quint.easeOut });
		});
		
	};

	return this.init();
};